/* eslint-disable no-unused-vars */
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  '@global': {
    'body.modal-open__side-panel': {
      overflow: 'hidden',
      height: '100vh',
      width: '100%',
      position: 'fixed',
    },
    'body::before': {
      content: '""',
      display: 'block',
      position: 'fixed',
      zIndex: 999,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      pointerEvents: 'none',
      opacity: 0,
    },
    'body.modal-open__side-panel::before': {
      pointerEvents: 'auto',
      opacity: 1,
      transition: 'opacity 300ms ease',
    },
  },
  container: {
    display: 'flex',
    position: 'fixed',
    opacity: 1,
    top: 0,
    zIndex: '1000',
    right: '-100vw',
    height: '100svh',
    maxHeight: '100dvh',
    fallbacks: {
      height: '100vh',
      maxHeight: '100vh',
    },
    width: '100vw',
    justifyContent: 'stretch',
    alignContent: 'stretch',
    transition: 'right 300ms ease',
  },
  containerOpen: {
    right: '0',
    transition: 'right 300ms ease',
  },
  containerLeft: {
    left: '-100vw',
    transition: 'left 300ms ease',
    flexDirection: 'row-reverse',
  },
  containerOpenLeft: {
    left: '0',
    transition: 'left 300ms ease',
  },
  panel: {
    minWidth: theme.mediaQueries.minimum,
    width: '100vw',
    maxWidth: theme.mediaQueries.mobile,
    height: '100svh',
    maxHeight: '100dvh',
    fallbacks: {
      height: '100vh',
      maxHeight: '100vh',
    },
    background: theme.colors.background,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-m)',
    padding: 'var(--ui-spacer-m)',
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      paddingTop: 'var(--ui-spacer-l)',
      paddingBottom: 'var(--ui-spacer-l)',
      paddingLeft: 'calc(var(--ui-spacer-s) + var(--ui-spacer-l))',
      paddingRight: 'calc(var(--ui-spacer-s) + var(--ui-spacer-l))',
    },
    [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
      maxWidth: '60rem',
    },
  },
  panelLeft: {
    [`@media (min-width: ${theme.mediaQueries.mobile}px)`]: {
      borderTopRightRadius: 'var(--ui-radius-xl)',
      borderBottomRightRadius: 'var(--ui-radius-xl)',
    },
  },
  panelRight: {
    [`@media (min-width: ${theme.mediaQueries.mobile}px)`]: {
      borderTopLeftRadius: 'var(--ui-radius-xl)',
      borderBottomLeftRadius: 'var(--ui-radius-xl)',
    },
  },

  separator: {
    border: 'none',
    borderBottom: `0.1rem solid ${theme.colors.gray300}`,
    padding: 0,
    margin: 0,
  },
  header: {
    display: 'flex',
    gap: 'var(--ui-spacer-s)',
  },
  closeButton: {
    flexShrink: 0,
    flexGrow: 0,
    transform: 'scale(1.5)',
    transformOrigin: 'right',
  },
  title: {
    margin: 0,
    fontSize: '2.4rem',
    lineHeight: 1,
    flex: 1,
  },
  content: {
    flex: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    // Make scrollbar outside of content
    paddingRight: 'var(--ui-spacer-m)',
    marginRight: 'calc(var(--ui-spacer-m) * -1)',
    // Make more visible space
    marginTop: 'calc(var(--ui-spacer-m) * -1)',
    marginBottom: 'calc(var(--ui-spacer-m) * -1)',
    paddingTop: 'var(--ui-spacer-m)',
    paddingBottom: 'var(--ui-spacer-m)',
  },
  footer: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-s)',

    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      paddingTop: 'var(--ui-spacer-m)',
    },
  },
  orderSummary: {
    padding: 0,
  },
  closeMenuTriggerArea: {
    width: '15vw',
    flex: 1,
    // backgroundColor: theme.colors.overlay,
    opacity: 0,
    userSelect: 'none',
    overflow: 'hidden',
    textIndent: '-9999em',
  },
  // closeMenuTriggerAreaOpen: {
  //   opacity: 1,
  //   transition: 'opacity 300ms ease',
  // },
}))

export default useStyles
